import { jsx } from "react/jsx-runtime";
import React from "react";
const HostContext = React.createContext(void 0);
const HostProvider = React.memo(
  ({ children, host }) => {
    return /* @__PURE__ */ jsx(HostContext.Provider, { value: host, children });
  }
);
function useHost() {
  const context = React.useContext(HostContext);
  if (context === void 0) {
    throw new Error("useHost must be used within a HostProvider");
  }
  return context;
}
export {
  HostContext,
  HostProvider,
  useHost
};
//# sourceMappingURL=host-context.js.map
